import './Card.css'

/**
 * Card component
 * @param details - card details to be passed with details like ** `title , text and altText 
 * @returns Card component containing card image , title and text
 */
export default function Card({ details }) {
    return (
        <div className="card flex-fill">
            <div className="card-image-container">
                <img src={details.src}
                    className="card-img-top" alt={details.altText} />
            </div>
                {details.link ?
                    (
                        <div className="d-flex justify-content-center">
                            <a href={details.link} target="_blank" rel="noopener noreferrer">
                                <h5 className="card-title">{details.title}</h5>
                                <p className="card-text">{details.text}</p>
                            </a>
                        </div>
                    ) : (
                        <div className="d-flex justify-content-center">
                            <h5 className="card-title">{details?.title}</h5>
                            <p className="card-text">{details?.text}</p>
                        </div>
                    )}
        </div>
    )
}